<template>
  <v-row class="my-0">
    <v-col
      cols="12"
      class="py-0"
    >
      <v-card class="py-4 px-4 mb-1 base-card d-flex justify-space-between align-center shadow">
        <v-btn
          class="action-btn elevation-0 rounded-lg"
          text
          small
          height="32"
          @click="goBack"
        >
          <v-icon class="uikit-icon chevron-left size-20" />
          <span class="ml-1 btn-text">Вернуться</span>
        </v-btn>
        <div class="title-card-buttons">
          <v-tooltip
            bottom
            :disabled="!isCreateWorkDisabled"
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  v-if="reviewButtonVisibility"
                  class="action-btn title-button rounded-lg"
                  height="32"
                  color="green darken-2"
                  small
                  :loading="reviewLoading"
                  :disabled="disabled || (saveLoading && !reviewLoading) || isCreateWorkDisabled"
                  @click="sendToReview"
                >
                  <v-icon class="uikit-icon account-eye-outline white size-20" />
                  <span class="ml-1 btn-text">Отправить на рассмотрение</span>
                </v-btn>
              </div>
            </template>
            <span> Отсутствует возможность отправки работы на рассмотрение в текущем квартале </span>
          </v-tooltip>

          <v-btn
            v-if="revisionButtonVisibility"
            class="action-btn title-button rounded-lg"
            height="32"
            color="blue-grey lighten-1"
            small
            :loading="revisionLoading"
            :disabled="disabled || acceptLoading || rejectLoading"
            @click=";(dialogType = 'revision'), openCommentDialog()"
          >
            <v-icon class="uikit-icon invoice-text-send-outline white size-20" />
            <span class="ml-1 btn-text">Отправить на доработку</span>
          </v-btn>

          <v-btn
            v-if="rejectButtonVisibility"
            class="action-btn title-button rounded-lg"
            height="32"
            small
            color="red darken-2"
            :loading="rejectLoading"
            :disabled="disabled || acceptLoading || revisionLoading"
            @click=";(dialogType = 'rejected'), openCommentDialog()"
          >
            <v-icon class="uikit-icon cancel white size-20" />
            <span class="ml-1 btn-text">Отклонить</span>
          </v-btn>

          <v-btn
            v-if="saveButtonVisibility"
            class="action-btn title-button rounded-lg"
            height="32"
            color="primary"
            small
            :loading="saveLoading && !reviewLoading"
            :disabled="disabled || reviewLoading || isNoChanges"
            @click="save"
          >
            <v-icon class="uikit-icon save white size-20" />
            <span class="ml-1 btn-text">Сохранить</span>
          </v-btn>

          <v-btn
            v-if="acceptButtonVisibility"
            class="action-btn title-button rounded-lg"
            height="32"
            color="green darken-2"
            small
            :loading="acceptLoading"
            :disabled="disabled || revisionLoading || rejectLoading"
            @click="setStatusToAccepted"
          >
            <v-icon
              class="uikit-icon check white size-20"
              style="margin-top: 1px"
            />
            <span class="ml-1 btn-text">{{ isWorkWithoutProcess ? 'Отправить' : 'Принять' }}</span>
          </v-btn>
        </div>
      </v-card>
    </v-col>

    <BaseDialog
      title="Комментарий"
      :isSend="true"
      :is-invalid="$v.$invalid"
      :dialog="commentDialog"
      :save-btn-loading="rejectLoading"
      @close="closeCommentDialog"
      @save="callAction"
    >
      <UITextArea
        v-model="rejectedComment"
        placeholder="Введите комментарий"
        :disabled="rejectLoading"
        :error-messages="errorMessages.rejectedComment"
        @input="$v.rejectedComment.$touch()"
      />
    </BaseDialog>
  </v-row>
</template>

<script>
import { commonWorkApi } from '../../../api'
import { getWorkTypeNameById, workStatusList, workStatusListName, workTypeName } from '@/scripts/consts'
import BaseDialog from '@/components/ui/BaseDialog.vue'
import UITextArea from '@/components/ui/UITextArea.vue'
import { required } from 'vuelidate/lib/validators'
import { setValidateMessages } from '@/scripts/validation'
import { mapGetters } from 'vuex'
import { createWorkDisabled } from '@/mixins/createWorkDisabled'

export default {
  name: 'TitleCard',
  components: { UITextArea, BaseDialog },
  mixins: [createWorkDisabled],

  props: {
    isShowMode: Boolean,
    isProcessMode: Boolean,
    isEditMode: Boolean,
    selectedItem: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    backRoute: {
      type: String,
      default: ''
    },
    isEditorialBoard: {
      type: Boolean,
      default: false
    },
    isNoChanges: Boolean
  },

  data: () => ({
    dialogType: '',
    commentDialog: false,
    acceptLoading: false,
    revisionLoading: false,
    rejectLoading: false,
    reviewLoading: false,
    rejectedComment: ''
  }),

  validations() {
    return {
      rejectedComment: { required }
    }
  },

  computed: {
    ...mapGetters('user', ['isModeratorNir', 'isAdmin', 'isModerator']),

    errorMessages() {
      const allErrors = {
        rejectedComment: setValidateMessages(this.$v.rejectedComment)
      }

      return allErrors
    },

    isWorkDraft() {
      return [workStatusListName.Draft].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },

    isWorkInProcess() {
      return [workStatusListName.Review].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },

    isWorkAccepted() {
      return [workStatusListName.Accepted].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },

    isWorkRevision() {
      return [workStatusListName.Revision].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },

    isWorkRejected() {
      return [workStatusListName.Rejected].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },

    isWorkActualization() {
      return [workStatusListName.Actualization].includes(workStatusList[this.selectedItem?.commonWork.status?.id])
    },
    isEfficiencyWork() {
      return ![workTypeName.PrePrint, workTypeName.Dissertation].includes(
        getWorkTypeNameById(this.selectedItem?.commonWork?.workType?.id)
      )
    },

    isWorkWithEffContractFlag() {
      return [
        workTypeName.Publication,
        workTypeName.Monography,
        workTypeName.Contest,
        workTypeName.StudentGuide,
        workTypeName.Performance
      ].includes(getWorkTypeNameById(this.selectedItem?.commonWork?.workType?.id))
    },

    isWorkWithoutProcess() {
      return [
        workTypeName.OverseasEvent,
        workTypeName.CooperationInformation,
        workTypeName.WinningScientificCompetition
      ].includes(getWorkTypeNameById(this.selectedItem?.commonWork?.workType?.id))
    },

    reviewButtonVisibility() {
      return (
        (this.isWorkDraft || this.isWorkRevision || this.isWorkActualization) &&
        this.isEditMode &&
        !this.isWorkWithoutProcess
      )
    },

    processWorkInProcessMode() {
      return this.isWorkInProcess && this.isProcessMode
    },

    acceptedWorkInShowMode() {
      return this.isShowMode && this.isWorkAccepted
    },

    rejectedWorkInShowMode() {
      return this.isShowMode && this.isWorkRejected
    },

    canChangeWorkInShowMode() {
      return this.isModeratorNir || this.isAdmin || this.isModerator
    },

    revisionButtonVisibility() {
      return (
        this.processWorkInProcessMode ||
        (this.canChangeWorkInShowMode &&
          ((this.acceptedWorkInShowMode && this.isEfficiencyWork) || this.rejectedWorkInShowMode))
      )
    },

    rejectButtonVisibility() {
      return (
        this.processWorkInProcessMode ||
        (this.acceptedWorkInShowMode && this.canChangeWorkInShowMode && this.isEfficiencyWork)
      )
    },

    saveButtonVisibility() {
      return (
        this.isEditMode ||
        (this.acceptedWorkInShowMode && this.canChangeWorkInShowMode && this.isWorkWithEffContractFlag)
      )
    },

    draftOrRevisionWorkWithoutProcessInEditMode() {
      return this.isWorkWithoutProcess && this.isEditMode && (this.isWorkDraft || this.isWorkRevision)
    },

    acceptButtonVisibility() {
      return (
        this.processWorkInProcessMode ||
        (this.rejectedWorkInShowMode && this.canChangeWorkInShowMode) ||
        this.draftOrRevisionWorkWithoutProcessInEditMode
      )
    }
  },

  inject: {
    saveWork: {
      default: () => {}
    }
  },

  methods: {
    goBack() {
      if (this.backRoute) {
        this.$router.push(this.backRoute)
        return
      }
      if (this.$router.history._startLocation !== this.$router.history.current.fullPath) this.$router.back()
      else this.$router.push('/')
    },

    save() {
      this.$emit('save')
    },

    openCommentDialog() {
      this.commentDialog = true
    },

    closeCommentDialog() {
      this.commentDialog = false
    },

    callAction() {
      this.closeCommentDialog()
      if (this.dialogType === 'revision') this.setStatusToRework()
      if (this.dialogType === 'rejected') this.setStatusToReject()
    },

    async sendToReview() {
      try {
        this.reviewLoading = true
        const isThrowErrorForSave = true
        if (!this.isNoChanges) await this.saveWork(isThrowErrorForSave)
        await commonWorkApi.sendToReview(this.selectedItem?.commonWork?.id)
        this.isEditorialBoard
          ? await this.$router.push('/journal-editorail-boards/journals')
          : await this.$router.push('/works/commonWork/allWorks')
        this.$toast.info('Работа отправлена на рассмотрение')
      } catch (e) {
        console.log(e)
        if (e.message !== 'Ошибка сохранения') this.showErrorMessage(e, 'Ошибка отправки на рассмотрение')
      } finally {
        this.reviewLoading = false
      }
    },

    async setStatusToReject() {
      try {
        this.rejectLoading = true
        const isThrowErrorForSave = true
        if (!this.isNoChanges) await this.saveWork(isThrowErrorForSave)
        const body = this.selectedItem.commonWork.getForAPI()
        body.comment = this.rejectedComment || null
        await commonWorkApi.decline(this.selectedItem?.commonWork?.id, body)
        this.isEditorialBoard
          ? await this.$router.push('/journal-editorail-boards/journals')
          : await this.$router.push('/works/commonWork/allWorks')
        this.$toast.info('Работа успешно отклонена')
        this.commentDialog = false
      } catch (e) {
        console.log(e)
        if (e.message !== 'Ошибка сохранения') this.showErrorMessage(e, 'Ошибка отклонения работы')
      } finally {
        this.rejectLoading = false
      }
    },

    async setStatusToRework() {
      try {
        this.revisionLoading = true
        const isThrowErrorForSave = true
        if (!this.isNoChanges) await this.saveWork(isThrowErrorForSave)
        const body = this.selectedItem.commonWork.getForAPI()
        body.comment = this.rejectedComment || null
        await commonWorkApi.sendToRevision(this.selectedItem?.commonWork?.id, body)
        this.isEditorialBoard
          ? await this.$router.push('/journal-editorail-boards/journals')
          : await this.$router.push('/works/commonWork/allWorks')
        this.$toast.info('Работа отправлена на доработку')
      } catch (e) {
        console.log(e)
        if (e.message !== 'Ошибка сохранения') this.showErrorMessage(e, 'Ошибка отправки на доработку')
      } finally {
        this.revisionLoading = false
      }
    },

    async setStatusToAccepted() {
      try {
        this.acceptLoading = true
        const isThrowErrorForSave = true
        if (!this.isNoChanges) await this.saveWork(isThrowErrorForSave)
        await commonWorkApi.accept(this.selectedItem?.commonWork?.id)
        this.isEditorialBoard
          ? await this.$router.push('/journal-editorail-boards/journals')
          : await this.$router.push('/works/commonWork/allWorks')
        this.$toast.info(`Работа ${this.isWorkWithoutProcess ? 'отправлена' : 'принята'}`)
      } catch (e) {
        console.log(e)
        if (e.message !== 'Ошибка сохранения')
          this.showErrorMessage(e, `Ошибка при ${this.isWorkWithoutProcess ? 'отправке' : 'принятии'} работы`)
      } finally {
        this.acceptLoading = false
      }
    }
  }
}
</script>

<style scoped>
.title-card-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
